import React from 'react'

import { 
    TeamContainerDiv, 
    TeamContainerContentsDiv,
    TeamContentsDiv,
    TeamSectionHeader,
    TeamMemberContainerDiv 
} from '../../Styles/Components/TeamContainerStyles'

import TeamMemberBox from './TeamMemberBox'

import shauryaIcon from '../../Icons/Team/shaurya-circle-icon.png'
import kushagraIcon from '../../Icons/Team/kushagra-circle-icon.png'

function TeamContainer(props) {

    let tmData = require('../../Data/team_data.json')

    let socialsIconsLinks = {
        "github": "https://cdn.jsdelivr.net/npm/simple-icons@v3/icons/github.svg",
        "linkedin": "https://cdn.jsdelivr.net/npm/simple-icons@v3/icons/linkedin.svg",
        "email": "https://cdn.jsdelivr.net/npm/simple-icons@v3/icons/gmail.svg",
        "twitter": "https://cdn.jsdelivr.net/npm/simple-icons@v3/icons/twitter.svg"
    }

    let teamMemberIcons = {
        "Shaurya Srivastava": shauryaIcon,
        "Kushagra Srivastava": kushagraIcon
    }

    return (
        <TeamContainerDiv id="team-section">
            <TeamContainerContentsDiv>
                <TeamContentsDiv>
                    <TeamSectionHeader>Our Team</TeamSectionHeader>
                    <TeamMemberContainerDiv>
                        {Object.keys(tmData).map(key => tmData[key].map(item => (
                            item.hide !== 'true' && <TeamMemberBox tmTitle={item.title} tmName={item.name} tmPersonalSite={item.personal_site} tmSocials={item.socials} tmImage={teamMemberIcons[item.name]} socialsIconsLinks={socialsIconsLinks} key={item.title+'-'+item.name}/>
                        )))}
                    </TeamMemberContainerDiv>
                </TeamContentsDiv>
            </TeamContainerContentsDiv>
        </TeamContainerDiv>
    )
}

export default TeamContainer